import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const WaitlistBrandPicks = ({ brands, picks, max }) => {
  const [sel, setSel] = useState(picks);
  const [saving, setSaving] = useState(false);

  const toggle = async (id) => {
    const next = sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id];
    if (next.length > max) { toast.message(`You can pick up to ${max} brands. Untick one first.`); return; }
    const prev = sel;
    setSel(next);
    setSaving(true);
    try {
      const r = await api.put("/rewards/gift-cards/waitlist/brands", { product_ids: next });
      setSel(r.data.picks);
    } catch {
      setSel(prev);
      toast.error("Could not save your brands. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (!brands.length) return null;
  return (
    <div className="mt-6 pt-5 border-t border-cyan-100" data-testid="waitlist-brand-picks">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-semibold text-slate-900">Which gift cards do you want most?</p>
        <span className="text-xs text-slate-500 tabular-nums whitespace-nowrap inline-flex items-center gap-1.5" data-testid="waitlist-brand-count">
          {saving && <Loader2 className="w-3 h-3 animate-spin" />}{sel.length} of {max} picked
        </span>
      </div>
      <p className="text-xs text-slate-500 mt-1">Pick up to {max}. It helps us choose which brands to offer first.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {brands.map((b) => {
          const on = sel.includes(b.id);
          return (
            <button key={b.id} onClick={() => toggle(b.id)} disabled={saving} aria-pressed={on}
                    className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-colors disabled:cursor-wait ${on
                      ? "bg-slate-900 border-slate-900 text-white"
                      : "bg-white border-slate-200 text-slate-700 hover:border-slate-400"}`}
                    data-testid={`waitlist-brand-${b.brand.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
              {on && <Check className="w-3 h-3" />}{b.brand}
            </button>
          );
        })}
      </div>
    </div>
  );
};
